import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, listItemStyles, Menu } from "@neru/ui";
import * as R from "ramda";
import { useRef } from "react";
import { toNameValueObject } from "../../utils/data-mappers";
import { isNotEmpty } from "../../utils/validators";
import * as S from "./styles";
export var Dropdown = function(param) {
    var tmp = param["data-testid"], testId = tmp === void 0 ? "dropdown" : tmp, _param_initFormElements = param.initFormElements, initFormElements = _param_initFormElements === void 0 ? R.identity : _param_initFormElements, items = param.items, _param_label = param.label, label = _param_label === void 0 ? "Select options" : _param_label, name = param.name, _param_selectedValues = param.selectedValues, selectedValues = _param_selectedValues === void 0 ? [] : _param_selectedValues;
    var menu = useRef(null);
    var normalizedItems = items.filter(isNotEmpty).map(toNameValueObject);
    var selectedValuesArray = (Array.isArray(selectedValues) ? selectedValues : [
        selectedValues
    ]).map(toNameValueObject).map(function(param) {
        var value = param.value;
        return value.toString();
    });
    return /*#__PURE__*/ _jsx(Menu, {
        "data-testid": testId,
        icon: "chevron-down-line",
        label: label,
        layout: "outlined",
        ref: menu,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "\n          bg-primary-0 py-2 text-primary-1000\n\n          dark:bg-primary-950 dark:text-primary-0\n        ",
            children: [
                /*#__PURE__*/ _jsx(S.DropdownBody, {
                    role: "group",
                    children: initFormElements(normalizedItems.map(function(param) {
                        var itemName = param.name, value = param.value;
                        return /*#__PURE__*/ _jsx("div", {
                            className: listItemStyles,
                            children: /*#__PURE__*/ _jsx(Checkbox, {
                                checked: selectedValuesArray.includes(value.toString()),
                                "data-testid": "".concat(testId, "-option-").concat(value),
                                label: String(itemName),
                                name: name,
                                value: String(value)
                            })
                        }, value);
                    }))
                }),
                /*#__PURE__*/ _jsx(S.DropdownFooter, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: "Done",
                        layout: "filled",
                        onClick: function() {
                            var _menu_current;
                            return (_menu_current = menu.current) === null || _menu_current === void 0 ? void 0 : _menu_current.close();
                        },
                        size: "condensed",
                        type: "button"
                    })
                })
            ]
        })
    });
};

//# sourceMappingURL=Dropdown.js.map